import { getStorageValue, setStorageValue } from '../../helpers/storage';

import { COLORS } from '../../constants/colors';
import { NOTIFICATION_TYPES } from './constants';

import {
  GetMessageDataType,
  GetNotificationType,
  GetSpecificNotificationType,
} from './interfaces';
import { StorageValues, StorageTypes } from '../../interfaces/storage';
import { CheckCircleIcon } from '@icons/CheckCircleIcon';
import { ExclamationMarkCircleIcon } from '@icons/ExclamationMarkCircleIcon';
import { ExclamationMarkCircleIconGrey } from '@icons/ExclamationMarkCircleIconGrey';

export const getMessageData: GetMessageDataType = (type) => {
  if (!type) {
    return {
      icon: null,
      colorIcon: '',
    };
  }
  const messageData = {
    [NOTIFICATION_TYPES.ERROR]: {
      icon: ExclamationMarkCircleIcon,
      colorIcon: COLORS.ERROR,
    },
    [NOTIFICATION_TYPES.WARNING]: {
      icon: ExclamationMarkCircleIcon,
      colorIcon: COLORS.WARNING,
    },
    [NOTIFICATION_TYPES.SUCCESS]: {
      icon: CheckCircleIcon,
      colorIcon: COLORS.SUCCESS,
    },
    [NOTIFICATION_TYPES.INFO]: {
      icon: ExclamationMarkCircleIconGrey,
      colorIcon: COLORS.WHITE,
    },
  };

  return messageData[type];
};

export const getNotification: GetNotificationType = ({
  title = '',
  message,
  ...props
}) => {
  return {
    title,
    message,
    ...props,
  };
};

export const getErrorNotification: GetSpecificNotificationType = ({
  title = '',
  message,
  ...props
}) => {
  return getNotification({
    title,
    message,
    type: NOTIFICATION_TYPES.ERROR,
    ...props,
  });
};

export const setDismissNotificationMessage = (
  message: string,
  storageType: StorageTypes,
) => {
  const dismissMessages =
    getStorageValue<string[]>(StorageValues.DismissMessages, storageType) || [];

  const finalMessage = message.slice(0, 80);

  setStorageValue(
    StorageValues.DismissMessages,
    dismissMessages.concat(finalMessage),
    storageType,
  );
};

export const checkIsDismissNotification = (
  message: string,
  storageType: StorageTypes,
): boolean => {
  const dismissMessages =
    getStorageValue<string[]>(StorageValues.DismissMessages, storageType) || [];

  const hasDismissMessage = dismissMessages.some((dismissMessage) =>
    message.toLowerCase().startsWith(dismissMessage.toLowerCase()),
  );

  return hasDismissMessage;
};
